<template>
  <section
    class="mt-10 bg-white rounded-md relative py-10 px-4"
    aria-label="Sıkça Sorulan Sorular"
    id="faqs"
  >
    <div class="max-w-7xl mx-auto">
      <div class="flex flex-row justify-between" aria-label="SSS Başlık">
        <div class="flex flex-row items-center gap-2 sm:gap-4">
          <div
            class="size-12 bg-orange-500 rounded flex items-center justify-center"
          >
            <Icon name="mdi:faq" class="text-white size-8" />
          </div>
          <h3 class="text-xl md:text-2xl font-bold">
            <span class="text-orange-500">Sıkça Sorulan</span>
            Sorular
          </h3>
        </div>
        <NuxtLink
          to="/faq"
          class="faq-light-orange flex flex-row items-center rounded gap-8 py-2 px-3"
          aria-label="Tüm Sorular"
        >
          <span class="text-orange-500 text-sm"> Tüm Sorular </span>

          <div class="bg-orange-500 rounded p-[2px]">
            <Icon name="tabler:arrow-up-right" class="text-white size-5" />
          </div>
        </NuxtLink>
      </div>
      <div>
        <FaqQuestions :questions="faq.data" />
      </div>
      <div class="faq-dots relative flex items-center justify-center">
        <div class="size-5 absolute bg-orange-500 rounded-full z-20"></div>
        <div class="size-7 absolute bg-orange-400 rounded-full z-10"></div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import FaqQuestions from './FaqQuestions.vue';

const { data: faq, error: faqError } = await useCustomFetch('/api/public/faqs')
</script>

<style scoped>
.faq-light-orange {
  background-color: #f4e7de;
}
.faq-dots {
  bottom: -40px;
}
</style>
